import React from 'react';
import PropTypes from 'prop-types';
import { removeHtml, getWords } from '../../domain/utils/stringUtils';
import { imageResponsiveService } from '../../domain/services/imageResponsiveService';

const handleOnError = e => {
  const fallbackSrc = '/images/transparent.png';
  if (e.target.src.indexOf(fallbackSrc) === -1) {
    e.target.src = fallbackSrc;
  }
};

export const ImageSimple = ({
  src,
  alt,
  title,
  width,
  height,
  loading,
  onLoad
}) => {
  const webpUrl = imageResponsiveService.getWebpUrl(src);
  return (
    <img
      src={webpUrl}
      width={width}
      height={height}
      alt={removeHtml(getWords(alt, 16)) || ''}
      title={removeHtml(getWords(title, 16))}
      loading={loading}
      onError={handleOnError}
      onLoad={onLoad}
    />
  );
};

ImageSimple.defaultProps = {
  alt: undefined,
  title: undefined,
  width: undefined,
  height: undefined,
  loading: 'lazy',
  onLoad: undefined
};

ImageSimple.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  onLoad: PropTypes.func
};
